<script>
  export let h = 20;
  export let w = 20;

  export let icon;
  export let classes;
</script>

<span class={`inline-block ${classes}`} style={`height: ${h}px; width: ${w}px`}>
  {#if icon === 'close'}
    <svg xmlns="http://www.w3.org/2000/svg" width="26.121" height="26.121" viewBox="0 0 26.121 26.121">
      <path d="m1.061 1.061 24 24m-24 0 24-24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
    </svg>
  {/if}

  {#if icon === 'filter'}
    <svg xmlns="http://www.w3.org/2000/svg" width="27.5" height="21.126" viewBox="0 0 27.5 21.126">
      <g transform="translate(.75 .75)" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M0 3.376h14.625" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21.124 3.376h4.875M11.54 16.375H26M0 16.375h4.875" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="3.099" cy="3.099" r="3.099" transform="translate(5.341 13.428)"/>
        <circle cx="3.099" cy="3.099" r="3.099" transform="translate(14.637)"/>
      </g>
    </svg>
  {/if}

  {#if icon === 'small-arrow-down'}
    <svg xmlns="http://www.w3.org/2000/svg" width="18.121" height="9.811" viewBox="0 0 18.121 9.811">
      <path d="m1.061 1.061 8 8 8-8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
    </svg>
  {/if}

  {#if icon === 'long-arrow-right'}
    <svg xmlns="http://www.w3.org/2000/svg" width="27.811" height="28.121" viewBox="0 0 27.811 28.121">
      <path d="m13.75 27.061 13-13m0 0-13-13m13 13h-26" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
    </svg>
  {/if}
</span>
